/**
 * Полоса прогресса: ручной гоалбар.
 *
 * РУЧНОЙ — И ЭТО РЕШЕНИЕ, А НЕ НЕДОДЕЛКА (docs/04). Автоматический
 * гоалбар должен знать про донаты, подписки и цели — то есть ходить
 * в чужой API, хранить чужие токены и ломаться каждый раз, когда
 * провайдер меняет формат. Для этого есть эмбед провайдера, который
 * он же и чинит. А здесь — полоса, которую двигает модератор
 * обычной операцией сцены.
 *
 * НИЧЕГО НЕ ТИКАЕТ. У прогресса нет своего времени: он меняется
 * только когда кто-то его подвинул, и между правками слой стоит
 * ровно так же, как картинка.
 */
import { whenFontsReady } from './fonts.js';
import { registerFont } from './fonts.js';
import { asRecord, color, numberInRange, oneOf } from './props.js';
import { applyTextStyle, parseTextStyle } from './text.js';
const TYPE = 'progress';
const LABELS = ['none', 'value', 'percent'];
/** Предел длины единицы. */
const MAX_UNIT = 16;
/** Верхняя граница значений: больше — почти наверняка опечатка. */
const MAX_VALUE = 1e12;
export const progressWidget = {
    type: TYPE,
    parse(raw) {
        const props = asRecord(TYPE, raw);
        return {
            value: numberInRange(TYPE, props, 'value', 0, MAX_VALUE, 0),
            max: numberInRange(TYPE, props, 'max', 0, MAX_VALUE, 100),
            fill: color(TYPE, props, 'fill', '#3fb950'),
            track: color(TYPE, props, 'track', '#21262d'),
            radius: numberInRange(TYPE, props, 'radius', 0, 1000, 0),
            label: oneOf(TYPE, props, 'label', LABELS, 'none'),
            text: parseTextStyle(TYPE, props),
            unit: optionalUnit(props),
        };
    },
    mount(props) {
        const el = document.createElement('div');
        el.dataset.widget = TYPE;
        el.style.position = 'relative';
        el.style.overflow = 'hidden';
        // Дорожка занимает весь слой: размер задаёт трансформ слоя,
        // а не свойства виджета — иначе полосу двигали бы двумя разными
        // способами, и они разошлись бы
        const track = document.createElement('div');
        track.dataset.role = 'track';
        track.style.position = 'absolute';
        track.style.inset = '0';
        const fill = document.createElement('div');
        fill.dataset.role = 'fill';
        fill.style.position = 'absolute';
        fill.style.inset = '0';
        // ЗАЛИВКА ЧЕРЕЗ scaleX, А НЕ ЧЕРЕЗ width. Смена ширины заставляет
        // браузер пересчитать раскладку, смена трансформа — только
        // композицию. В эфире это разница между плавным движением
        // и дёрганым, и заметна она именно на машине стримера, где
        // процессор занят игрой и кодировщиком
        fill.style.transformOrigin = 'left center';
        const label = document.createElement('span');
        label.dataset.role = 'label';
        label.style.position = 'relative';
        label.style.display = 'block';
        track.append(fill);
        el.append(track, label);
        let current = props;
        registerFont({ family: props.text.font, src: props.text.fontSrc });
        apply(el, track, fill, label, current);
        const unwatch = whenFontsReady(() => {
            applyTextStyle(label, current.text);
        });
        return {
            el,
            update(next) {
                current = next;
                registerFont({ family: next.text.font, src: next.text.fontSrc });
                apply(el, track, fill, label, next);
            },
            destroy() {
                unwatch();
                el.remove();
            },
        };
    },
    preload(props) {
        registerFont({ family: props.text.font, src: props.text.fontSrc });
    },
};
/**
 * Какая доля полосы залита, 0..1.
 *
 * НУЛЕВАЯ ЦЕЛЬ ДАЁТ ПУСТУЮ ПОЛОСУ, а не деление на ноль и не полную.
 * Ноль здесь означает «цель не задана», и рисовать достигнутой
 * незаданную цель — это поздравить стримера с тем, чего не было.
 *
 * ПЕРЕБОР ПРИЖИМАЕТСЯ. Донатов может прийти больше цели — это
 * праздник, а не повод вылезти заливкой за края слоя.
 */
export function ratio(props) {
    if (props.max <= 0)
        return 0;
    return Math.min(1, Math.max(0, props.value / props.max));
}
/** Что написано поверх полосы. */
export function labelText(props) {
    switch (props.label) {
        case 'percent':
            return `${Math.round(ratio(props) * 100)}%`;
        case 'value': {
            const unit = props.unit === '' ? '' : ` ${props.unit}`;
            return `${round(props.value)} / ${round(props.max)}${unit}`;
        }
        default:
            return '';
    }
}
/**
 * Дробное показывается дробным, целое — целым.
 *
 * «1500 / 2000» читается с одного взгляда, «1500.00 / 2000.00» —
 * нет, а гоалбар смотрят краем глаза.
 */
function round(value) {
    return Number.isInteger(value) ? String(value) : value.toFixed(2);
}
function optionalUnit(props) {
    const value = props.unit;
    if (typeof value !== 'string')
        return '';
    return value.trim().slice(0, MAX_UNIT);
}
function apply(el, track, fill, label, props) {
    /* eslint-disable no-param-reassign --
       Правило бережёт неизменяемость СОСТОЯНИЯ, а здесь меняется DOM —
       ровно то, ради чего функция и существует. */
    el.style.borderRadius = `${props.radius}px`;
    track.style.background = props.track;
    fill.style.background = props.fill;
    fill.style.transform = `scaleX(${ratio(props)})`;
    const text = labelText(props);
    if (label.textContent !== text) {
        label.textContent = text;
    }
    /* eslint-enable no-param-reassign */
    applyTextStyle(label, props.text);
}
//# sourceMappingURL=progress.js.map